import React from "react";

// const SkillsValue = ({ skills, selectedKey }) => {
//   return (
//     <div className="p-4">
//       <h2 className="text-xl font-semibold mb-4">
//         {selectedKey.charAt(0).toUpperCase() + selectedKey.slice(1)} Skills
//       </h2>
//       <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
//         {skills[selectedKey].map((skill) => (
//           <div
//             key={skill}  className="skill-card"
//             // className="bg-white p-2 rounded shadow text-center font-medium"
//           >
//             {skill}
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };
const SkillsValue = ({ skills, selectedKey }) => {
  const selectedCategory = skills[selectedKey];

  if (!selectedCategory) return null; // safely handle undefined

  const selectedSkills = selectedCategory.items;
  // if (!selectedSkills || selectedSkills.length === 0) return null;

  // const selectedSkills = skills[selectedKey].items;

  const getLevelIcon = (level) => {
    switch (level) {
      case "Expert":
        return "🌟";
      case "Intermediate":
        return "⭐";
      case "Beginner":
        return "⭐";
      default:
        return "⚪";
    }
  };

  return (
    <div className="p-4">
     <div className="skillsValue-heading flex items-center gap-3 mb-4">
  <span className="text-xl">{skills[selectedKey].icon}</span>
  <h2 className="text-xl font-bold text-blue-800">
    {selectedKey}
  </h2>
</div>


      <div className="grid grid-cols-2 gap-4 p-4">
        {selectedSkills.map((skill, index) => (
          <div
            key={index}
            className="flex items-center p-2 bg-white rounded shadow"
          >
            <span className="font-semibold mr-2">{skill.name}</span>
            {/* <span
              className={`text-sm ml-auto font-medium ${getLevelColor(
                skill.level
              )}`}
            >
              {skill.level}
            </span> */}
            <span className="text-sm ml-auto">{getLevelIcon(skill.level)}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SkillsValue;
